import { render, staticRenderFns, recyclableRender, components } from "./countdown-act.vue?vue&type=template&id=1cc003a6&"
var renderjs
import script from "./countdown-act.vue?vue&type=script&lang=js&"
export * from "./countdown-act.vue?vue&type=script&lang=js&"
import style0 from "./countdown-act.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/countdown/countdown-act.vue"
export default component.exports